module.exports = __webpack_public_path__ + "static/media/mk.2413b107.svg";